<template>
  <div style="margin-top: 20px">
    <v-btn-toggle
      v-model="data.ContactIcon" 
      @change="handleChangeIsModified"
    >
      <v-btn :value="'mdi-map-marker'" @click="data.ContactIcon = 'mdi-map-marker'" text>
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>
      <v-btn :value="'mdi-clock-outline'" @click="data.ContactIcon = 'mdi-clock-outline'" text>
        <v-icon>mdi-clock-outline</v-icon>
      </v-btn>
      <v-btn :value="'mdi-phone'" @click="data.ContactIcon = 'mdi-phone'" text>
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn :value="'mdi-whatsapp'" @click="data.ContactIcon = 'mdi-whatsapp'" text>
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn :value="'mdi-email'" @click="data.ContactIcon = 'mdi-email'" text>
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn :value="'mdi-web'" @click="data.ContactIcon = 'mdi-web'" text>
        <v-icon>mdi-web</v-icon>
      </v-btn>
      <v-btn :value="'mdi-youtube'" @click="data.ContactIcon = 'mdi-youtube'" text>
        <v-icon>mdi-youtube</v-icon>
      </v-btn>
      <v-btn :value="'mdi-twitter'" @click="data.ContactIcon = 'mdi-twitter'" text>
        <v-icon>mdi-twitter</v-icon>
      </v-btn>
      <v-btn :value="'mdi-facebook'" @click="data.ContactIcon = 'mdi-facebook'" text>
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn :value="'mdi-linkedin'" @click="data.ContactIcon = 'mdi-linkedin'" text>
        <v-icon>mdi-linkedin</v-icon>
      </v-btn>
      <v-btn :value="'mdi-instagram'" @click="data.ContactIcon = 'mdi-instagram'" text>
        <v-icon>mdi-instagram</v-icon>
      </v-btn>
    </v-btn-toggle>
    <br>
    <translate
      v-if="!isAddress"
      v-model="data.ContactDescription"
      :languages="languages"
      :label="$t('contact.description')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <div
      v-else
    >
      <!-- <div style="padding-left: 10px; padding-right: 10px;">
        <address-find
          :id="id"
          :onUpdateAddress="handleUpdateAddress"
        />
      </div> -->
      <div style="margin: 10px -10px;background-color:#EAEAEA; padding: 20px 15px 0 15px;">
        <div style="padding: 0 10px 0 10px;">
          <address-find
            :id="id"
            :onUpdateAddress="handleUpdateAddress"
          />
        </div>
        <v-layout align-center wrap style="margin-top: -10px;padding:0 0px 20px 0px;">
          <v-flex xs6 style="padding-right: 5px;">
              <v-text-field
                v-model="lat"
                append-icon="mdi-search"
                :label="$t('map.lat')"
                hideDetails
                @input="handleChangeLat"
              />
            </v-flex>
            <v-flex xs6 style="padding-left: 5px;">
              <v-text-field
                v-model="lon"
                append-icon="mdi-search"
                :label="$t('map.lon')"
                hideDetails
                @input="handleChangeLon"
              />
          </v-flex>
              <translate
                v-model="data.ContactDescription"
                :languages="languages"
                :label="$t('contact.description')"
                @input="handleChangeIsModified"
                style="padding: 0 10px 0 10px;"
              />
              <br>
        </v-layout>
      </div>
    </div>
    <div 
      v-if="isURL"
    >
      <br>
      <translate
        v-model="data.ContactURL"
        :languages="languages"
        :label="$t('contact.url')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
    </div> 
    <v-btn
      dark
      style="float: right"
      color="red"
      @click="onDelete(data.ID)"
    >
      {{$t('common.delete')}}
    </v-btn>
    <v-divider style="margin-top: 50px;"/>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  import Translate from '@/components/Translate'
  import AddressFind from '@/components/AddressFind'
  export default {
    components: {
      Translate,
      AddressFind
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      onDelete: {
        type: Function,
        required: false,
        default: null
      },
      id: {
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      showConfirmDelete: false,
      isURL: false,
      isAddress: false,
      lat: null,
      lon: null
    }),
    computed: {
      ...mapState('app',['locale']),
      languages () {
        return this.$store.state.app.Languages
      }
    },
    mounted () {
      if (!this.data.ContactURL) this.data.ContactURL = { es: '', en: ''}
      if (!this.data.ContactLatLon) {
        this.data.ContactLatLon = { Lat: '', Lon: ''}
      } else {
        this.lat = this.data.ContactLatLon.Lat
        this.lon = this.data.ContactLatLon.Lon
      }
      this.checkIsURL()
      this.checkIsAddress()
    },
    methods: {
      handleChangeLat () {
        this.data.ContactLatLon.Lat = this.lat
        this.handleChangeIsModified()
      },
      handleChangeLon () {
        this.data.ContactLatLon.Lon = this.lon
        this.handleChangeIsModified()
      },
      handleUpdateAddress (address) {
        this.handleChangeIsModified()
        const aux = this.data.ContactDescription
        aux[this.locale] = address.address
        for (let i = 0; i < this.$store.state.app.contents.length; i++) {
          for (let j = 0; j < this.$store.state.app.contents[i].ContactItems.length; j++) {
            if (this.$store.state.app.contents[i].ContactItems[j].ID === this.data.ID) {
              this.$store.state.app.contents[i].ContactItems[j].ContactLatLon = {
                                                                    Lat: address.lat,
                                                                    Lon: address.lon
                                                                  }
              this.$store.state.app.contents[i].ContactItems[j].ContactDescription = aux
              this.lat = address.lat
              this.lon = address.lon
            }
          }
        }
      },
      handleChangeIsModified () {
        this.checkIsURL()
        this.checkIsAddress()
        this.$store.state.app.isModified = true
      },
      checkIsAddress() {
        const aux = [
          'mdi-map-marker'
        ]
        this.isAddress = (aux.indexOf(this.data.ContactIcon) >= 0)
        if (!this.isAddress) {
          this.data.ContactLatLon = {Lat: '', Lon: ''}
        }
      },
      checkIsURL() {
        const aux = [
          'mdi-email',
          'mdi-web',
          'mdi-youtube',
          'mdi-twitter',
          'mdi-facebook',
          'mdi-linkedin',
          'mdi-instagram'
        ]
        this.isURL = (aux.indexOf(this.data.ContactIcon) >= 0)
        if (!this.isURL) this.data.ContactURL = {es: '', en: ''}
      }
    }
  }
</script>

<style scoped>
</style>

